import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import TextControl from "apps/website/components/base/Text/TextControl/TextControl";
import Spacer from "apps/website/components/layout/Spacer/Spacer";
import { IStoryBlokComponent } from "apps/website/components/page/api.types";

export interface IArticleContentsHeading {
  text: string;
  id: string;
}

export interface IStoryBlokArticleContents {
  title?: string;
}

export interface IStoryBlokArticleContentsProps
  extends IStoryBlokComponent<IStoryBlokArticleContents> {
  headings?: IArticleContentsHeading[];
}

export const StoryBlokArticleContents = ({
  blok,
  headings = [],
}: IStoryBlokArticleContentsProps) => {
  if (!headings.length) {
    return null;
  }

  return (
    <>
      <nav
        aria-label={blok.title || "In this article"}
        className="flex flex-col gap-4 bg-functional-info p-4"
      >
        <TextSubtitle tag="div" size={2} className="uppercase leading-looser text-black">
          { blok.title || "In this article" }
        </TextSubtitle>
        <ul className="flex flex-col gap-2 pl-2">
          { headings.map((heading) => (
            <li key={heading.id}>
              <a href={`#${heading.id}`}>
                <TextControl
                  tag="span"
                  size={2}
                  className="text-functional-info tracking-tighter leading-none hover:underline"
                >
                  { heading.text }
                </TextControl>
              </a>
            </li>
          )) }
        </ul>
      </nav>
      <Spacer size="xl" />
    </>
  );
};
